<template>
<div class="home">
    <CustomNav :showButtons="true" :showHomeBtn="true" :navBarTitle="'详情'" />
    <div v-if="!showLoading">
        <swiper :options="swiperOption">
            <swiperSlide v-for="(item,index) in oData.pet_image_more">
                <div @click="showPreview" class="petImg" :style="'background-image:url(' + imgUrl + item.image + ')'"></div>
            </swiperSlide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="petDetail" :class="isIphoneX && 'iphonexPetDetail'">
            <div class="petInfoCont">
                <div class="petTopCont">
                    <div class="petName">{{oData.pet_name}}</div>
                    <div class="flex-center petSex">
                        <img v-if="oData.pet_sex == 1" src="/img/man3x.png"></img>
                        <img v-if="oData.pet_sex == 2" src="/img/girl3x.png"></img>
                    </div>
                </div>
                <div class="petui-pet-info">
                    <div class="petui-pet-flex petui-label-content">
                        <div class="flex-center petui-label">#{{oData.vaccine == 1 ? '已免疫' : '未免疫'}}</div>

                        <div class="flex-center petui-label">
                            #{{oData.is_sterilization}}
                        </div>
                        <div class="flex-center petui-label">
                            #{{oData.is_repellent == 0 ? "未驱虫" : "已驱虫"}}
                        </div>
                        <div class="flex-center petui-label">
                            #{{oData.pet_age}}
                        </div>
                    </div>
                    <div class="petCity">
                        <img src="/img/site3x.png"></img>
                        <div>{{oData.city_name + ' '+ oData.area_name}}</div>
                    </div>
                </div>
            </div>
            <div wx-if="oData.pet_desc != ''" class="petDesc">
                <div class="petTitle">
                    <img src="/img/petDesc3x.png"></img>
                    <p>宠物描述</p>
                </div>
                <div class="petDescDetail">
                    <p>{{oData.pet_desc}}</p>
                </div>
            </div>
            <div wx-if="oData.adopt_require != ''" class="petRequire">
                <div class="petTitle">
                    <img src="/img/askfor3x.png"></img>
                    <p>领养要求</p>
                </div>
                <div class="petDescDetail">
                    <p>{{oData.adopt_require}}</p>
                </div>
            </div>

            <div class="fixedBottom">
                <div class="submitBtn" :class="isIphoneX && 'iphoneX'" @click="submitFn" data-id="oData.pet_id">带Ta回家</div>
                <div v-if='isIPhoneX' class='iPhoneX'></div>

            </div>
        </div>
    </div>
    <div class="codeContent" v-if="showCode" @click="hideCode">
        <img :src="codeUrl" alt="">
        <span>长按二维码识别小程序免费领养</span>
    </div>
    <div class="previewContent" v-if="isPreview" @click="hidePreview">
        <swiper :options="swiperOptionPreview">
            <swiperSlide v-for="(item,index) in oData.pet_image_more">
                <img @click="hidePreview" class="petImg" :src="imgUrl + item.image" alt="">
                <!-- <div @click="hidePreview" class="petImg" :style="'background-image:url(' + imgUrl + item.image + ')'"></div> -->
            </swiperSlide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
    <Loading :type="'circle'" v-if="showLoading" :tips="''" />
    <Tips :show="showTips" :tips="tipsText" />
</div>
</template>

<script>
// @ is an alias to /src
import {
    swiper,
    swiperSlide,
} from 'vue-awesome-swiper';
import wx from 'weixin-js-sdk';
import Loading from '@/components/Loading.vue';
import List from '@/components/List.vue';
import CustomNav from '@/components/CustomNav.vue';
import NoMore from '@/components/NoMore.vue';
import Tips from '@/components/Tips.vue';
import { wxShare } from '@/utils/wxShare.js';
import { isIPhoneX,isWeixin, } from '@/utils/index.js';
import {
    fetchDetail,
} from '@/api/getAdoptInfo';
import {
    getCode,
} from '@/api/getCode';
import {
    fetchJsApiConfig,
} from '@/api/getJsApiConfig';

export default {
    name: 'home',
    components: {
        Loading,
        CustomNav,
        swiper,
        swiperSlide,
        Tips,
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isIphoneX: false,
            petId: this.$route.query.id.toString(),
            showLoading: true,
            isPreview: false,
            showCode: false,
            oData: '',
            imgUrl: '',
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
            },
            swiperOptionPreview: {
                autoHeight: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
            },
            codeUrl: '',
            showTips: false,
            tipsText: '',
        };
    },
    created() {
        this.isIPhoneX = isIPhoneX() && !isWeixin() && window.history.length <= 1
    },
    mounted() {
        fetchDetail({
            pet_id: this.petId,
        }).then((response) => {
            const oData = response.data;
            if (oData.code == 1) {
                this.oData = oData.data;
                this.imgUrl = oData.img_url;
                this.showLoading = false;
                wxShare({
                    title: this.oData.pet_name + '-' + this.oData.city_name,
                    desc: this.oData.pet_desc || '',
                    imgUrl: this.imgUrl + this.oData.pet_image_more[0].image || '/img/petLogo.png',
                    success: () => {
                        // 设置成功
                    },
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    },
    methods: {
        showPreview() {
            this.isPreview = true;
        },
        hidePreview() {
            this.isPreview = false;
        },
        submitFn() {
            getCode({
                page_path: 'pages/releaseDetail/releaseDetail?id=' + this.petId,
            }).then((response) => {
                const oData = response.data;
                if (oData.code == 1) {
                    this.codeUrl = oData.img_url + oData.data.visit_path;
                    this.showCode = true;
                }
            }).catch((err) => {
                console.log(err);
                this.showTips = true;
                this.tipsText = '加载失败，请稍后再试～';
                setTimeout(() => {
                    this.showTips = false;
                    this.tipsText = '';
                }, 2000);
            });
        },
        hideCode() {
            this.showCode = false;
        },
    },
};
</script>
<style lang="scss">
@import '@/assets/style/petui.scss';
p {
    display: inline;
}
.codeContent {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99998;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.codeContent img {
    width: 65%;
    height: auto;
    max-width: 220px;
    margin-bottom: 20px;
}
.codeContent span {
    font-size: 17px;
}
.previewContent {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
}
.petImg {
    width: 100%;
    padding-top: 100%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
}
.previewContent .petImg {
    padding: 0;
}
.slideItem {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
}

.slideImage {
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.petDetail {
    padding: 0 15px 48px;
}
.petInfoCont {
    position: relative;
    padding: 20px 0;
    border-bottom: 1px solid #e5e5e5;
}

.petTopCont {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.petTop {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 20px;
    line-height: 20px;
}

.petName {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    height: 20px;
    color: #2d2d2d;
    letter-spacing: 0;
    line-height: 20px;
    max-width: 80%;
    margin-right: 9px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
}
.petCity {
    font-size: 14px;
    color: #333;
    font-family: PingFangSC-Regular;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.petCity img {
    width: 13px;
    height: 15px;
    margin-right: 5px;
}
.petVaccine {
    width: 21px;
    height: 22px;
}

.petVaccine img {
    width: 100%;
    height: 100%;
}

.petBottom {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.petBottom img {
    width: 8px;
    height: 9px;
    margin-right: 4px;
}

.petLeft {
    color: #fff;
    font-size: 12px;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.petLeft img {
    width: 10px;
    height: 10px;
    margin-right: 4px;
}
.petLeft .petui-pet-age img {
    width: 12px;
    height: 11px;
    margin-right: 4px;
}
.petSex {
    height: 18px;
}

.petSex img {
    width: 16px;
    height: 16px;
}

.petAge {
    margin: 0 10px;
}

.petAge,
.petRight {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #888;
    letter-spacing: 0;
    line-height: 14px;
}

.petDesc {
    padding-bottom: 15px;
    border-bottom: 1px solid #e5e5e5;
}

.petTitle {
    padding: 15px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.petDescDetail p {
    font-family: PingFangSC-Regular;
    font-size: 15px;
    color: #2d2d2d;
    line-height: 23px;
}

.petTitle img {
    width: 18px;
    height: 18px;
    margin-right: 7px;
}

.petTitle p {
    font-family: PingFangSC-Medium;
    font-size: 17px;
    color: #c5c5c5;
    letter-spacing: 0;
    line-height: 17px;
}

.petRequire {
    padding-bottom: 40px;
}
.fixedBottom{
    max-width: 768px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
}
.submitBtn {
    background: #fcd549;
    margin: 0 auto;
    height: 49px;
    line-height: 49px;
    text-align: center;
    font-size: 17px;
    color: #fff;
}
.iPhoneX {
    width: 100%;
    height: 34px;
    background: #fff;
}
.detailModel {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.50);
    z-index: 8;
    transform: scale(0, 0);
}

.shareBtn {
    position: absolute;
    right: 0;
    top: 20px;
    margin: -4px 0 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 0;
    flex-direction: column;
    font-size: 12px;
    color: #888;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100%;
    padding: 0;

}

.shareBtn::after {
    border: 0;
}

.ellipsis {
    max-width: 100%;
    overflow: hidden;
    p-overflow: ellipsis;
}

.ellipsis50 {
    max-width: 50%;
    white-space: nowrap;
    p-overflow: ellipsis;
    overflow: hidden;
}

.copy {
    width: 96rpx;
    height: 40rpx;
    line-height: 40rpx;
    p-align: center;
    font-size: 12px;
    color: #f7ce3e;
    background: #fff;
    border: 1rpx solid #fff;
    border-radius: 6rpx;
    margin-left: 16rpx;
}

.giverLabel {
    width: 100rpx;
    height: 30rpx;
    p-align: justify;
}

.giverLabel::after {
    width: 100%;
    display: inline-block;
    content: '';
}

.giverRight {
    margin-top: -40rpx;
}
.homeBtn {
    position: fixed;
    right: 30rpx;
    bottom: 240rpx;
    width: 70rpx;
    height: 70rpx;
    p-align: center;
    font-size: 28rpx;
    color: #fff;
    border-radius: 50%;
    background-color: #fff;
    background-size: 60%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAACsklEQVR4Xu2b8TXEQBDGv6sAFaADKkAFqAAVoAJUgApQASpABagAHdCB993L3ss7JzuTnd1kk51/7p9Nct8vO5PZmd0JRm6TDvTvAdgFsAZgG8AngDcAzwCuU/+flACWAVwCOGwQSRBHFZAkLFIB2ABwX711iTBCuJUMDB2TAgDf/BMAQtBYEgixAbQV70DtA3jQUNOOjQkgVDy1fAPYiRkTYgGwEO9eZlQIMQBYio8OwRpADPFRIVgDYLRnchPLzN3BEsCNJ8mxgmIKwQpAKvEOItPnzeorEQTWAkBq8U4w02Z+IjkjWlsogK7Em0EIAdC1eBMIbQH0RXwwhDYAuJwlgL5Zq5igBdBX8fWZwK+D2DQA+i7eiWYdgUtpkUkB5CJeDUECIDfxKgg+ALmKF0NoAsBFDRc3uVtjTPgPAOt3FM/l7RDsXwiLAAxNvHuBpwCu5t/mPIChine6/1Sa6wCGLn4hBAeAvv6qaFzkHhdm5XYHgEHiIHdViv/PGsI6awkEwCblh+LioQydBkUCYLeWfbux2SO1FwCVC3AtvTSyKTANhC4Ijs0N7lwJv54HMPfn4oe/qwOdDfR77kSZZYS+1SA58IKtTIF49XkHFABlBpi5wI9wowMTM6sY5J3h3gGGLrCiaGNZxR2vPu8AIwAvyrb5OYAzg8Dr1ecdUADYBMEyA4oL6LbOlBhQgmD5CpTPYMkDSiIUTsCb6HkHlEywZILTAws85BRiWafCFllZFwC+JK0+SQw4qU575TYDRNAlANg1ZuM0xER/pvYAi1l3AYD3aTQJAIvKcBcA2PzkrnITAKH7hVID4AlUuq7XpDOAN2Iz4dh7x8UDUgJ415xR1ACgtLa+mQoAn8M2n/gMgRYAIbBsTRB8kLShGhMAy+2sInOTh/qQZRsALb2gn5f9Akz2rUHqDfOnAAAAAElFTkSuQmCC");
}
</style>
